module.exports = __webpack_public_path__ + "static/img/img9.ab8fbda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/img9.jpg
// module id = NCju
// module chunks = 0